/* ==============================================
 * custom-properties.css
 * GENERATED FILE - DO NOT EDIT MANUALLY
 *
 * Source: client/web/client_modules/shells/react/components/tokens/
 * To regenerate: yarn generate:css-properties
 * ============================================== */

:root {
    /* Palette */
    --grey-0: #ffffff;
    --grey-50: #f7f7f7;
    --grey-100: #f1f1f1;
    --grey-200: #ebe8e8;
    --grey-300: #dbd9d9;
    --grey-400: #d4d1cf;
    --grey-500: #a6a3a1;
    --grey-600: #7a7370;
    --grey-700: #4d4540;
    --grey-800: #211712;
    --grey-900: #000000;
    --off-white-transparent: rgba(247, 247, 247, 0);
    --modal-overlay: hsla(234, 18%, 25%, 0.67);
    --red-50: #fff7f7;
    --red-100: #ffe5e7;
    --red-200: #ffd6d9;
    --red-300: #ffb2bb;
    --red-400: #ff596b;
    --red-500: #ff2e47;
    --red-600: #db293e;
    --red-700: #bf2436;
    --red-800: #73121d;
    --red-900: #4d0c13;
    --orange-50: #fff7f5;
    --orange-100: #ffeee5;
    --orange-150: #ffdecc;
    --orange-200: #ffccb2;
    --orange-300: #ffae80;
    --orange-400: #ff7833;
    --orange-500: #fe5800;
    --orange-600: #ea7134;
    --orange-700: #bf4200;
    --orange-800: #8e3200;
    --orange-900: #662400;
    --yellow-50: #fffcf7;
    --yellow-100: #fff8e5;
    --yellow-150: #fff5d9;
    --yellow-200: #fff0c5;
    --yellow-300: #fde9b4;
    --yellow-400: #ffde73;
    --yellow-500: #fac947;
    --yellow-600: #e1b233;
    --yellow-700: #bd9633;
    --yellow-800: #a37d23;
    --yellow-900: #7e6019;
    --green-50: #f7fcf7;
    --green-100: #ecf9ef;
    --green-200: #d6f2de;
    --green-300: #c4eecc;
    --green-400: #5ccf73;
    --green-500: #33c252;
    --green-600: #2e9942;
    --green-700: #0b8d6c;
    --green-800: #165024;
    --green-900: #113c1b;
    --navy-50: #ebf5fb;
    --navy-100: #d8ecf7;
    --navy-200: #c0e0f2;
    --navy-300: #7d9ace;
    --navy-400: #5977a4;
    --navy-500: #0c57ad;
    --navy-600: #065289;
    --navy-750: #1c2c48;
    --navy-800: #1c293f;
    --navy-900: #142034;
    --nutshell-pro: #4f86c6;
    --dotcom-teal: #62d4ca;
    --blue-50: #e8f4fa;
    --blue-100: #d9edf7;
    --blue-150: #c0e0f2;
    --blue-200: #b1d8ef;
    --blue-300: #94d1fe;
    --blue-400: #61b2de;
    --blue-500: #3b9ed7;
    --blue-600: #337da8;
    --blue-700: #235f81;
    --blue-800: #183f56;
    --blue-900: #0c202b;
    --plum-50: #e9e9f6;
    --plum-100: #dbdbf2;
    --plum-200: #c8c8e9;
    --plum-300: #acace1;
    --plum-400: #7373c7;
    --plum-500: #514fb8;
    --plum-600: #3d3b8a;
    --plum-700: #292967;
    --plum-800: #20204a;
    --plum-900: #101025;
    --purple-10: #fbfaff;
    --purple-50: #f2eefb;
    --purple-100: #e6ddf7;
    --purple-200: #e2a9ff;
    --purple-300: #bb97f6;
    --purple-400: #a378f6;
    --purple-500: #8b5cf6;
    --purple-600: #7744e1;
    --purple-700: #602bcc;
    --purple-800: #4d22a3;
    --purple-900: #321273;
    --dotcom-purple: #660347;
    --slate-100: #eeeff4;
    --slate-200: #e5e6ee;
    --slate-300: #c8cadb;
    --slate-400: #9397ba;
    --slate-500: #5c5f87;
    --slate-550: #3f4372;
    --slate-600: #3d405c;
    --slate-650: #333557;
    --slate-700: #333766;
    --slate-800: #242854;
    --slate-900: #0c0f33;
    --slate-950: #0a0d2b;
    --messenger-blue: #3b5998;
    --instagram-pink: #dd2a7b;
    --whatsapp-green: #25d366;
    --whatsapp-green-dk: #075e54;
    --zoom-blue: #0b5cff;
    --google-green: #05ac47;
    --teams-blue: #464eb8;
    --social-twitter: #00aced;
    --social-linkedin: #007bb6;
    --social-foursquare: #ef4b78;
    --social-pinterest: #cb2027;
    --social-youtube: #e52d27;
    --social-flickr: #ff0084;
    --social-vimeo: #aad450;
    --social-google-plus: #dd4b39;
    --social-tumblr: #35465c;
    --social-dribbble: #ea4c89;
    --social-behance: #1769ff;
    --social-delicious: #3399ff;
    --social-hacker-news: #ff6600;
    --social-instagram: #3f729b;
    --social-lastfm: #c3000d;
    --social-reddit: #ff4500;
    --social-twitch: #6441a5;
    --social-vine: #00b488;

    /* Semantic Colors */
    --white: var(--grey-0);
    --off-white: var(--grey-50);
    --off-white-md: var(--grey-200);
    --off-white-dk: var(--grey-200);
    --grey-xlt: var(--grey-400);
    --grey-lt: var(--grey-600);
    --grey: var(--grey-700);
    --grey-dk: var(--grey-800);
    --black: var(--grey-900);
    --rose-xlt: var(--red-50);
    --rose-lt: var(--red-200);
    --red-lt: var(--red-200);
    --rose: var(--red-500);
    --red: var(--red-500);
    --rose-dk: var(--red-700);
    --orange-xlt: var(--orange-100);
    --orange-bg: var(--orange-100);
    --orange-lt: var(--orange-150);
    --orange: var(--orange-500);
    --orange-attention: var(--orange-600);
    --orange-dk: var(--orange-700);
    --brown-lt: var(--yellow-150);
    --brown: var(--yellow-200);
    --brown-dk: var(--yellow-700);
    --yellow-bg: var(--yellow-50);
    --yellow-lt: var(--yellow-150);
    --yellow: var(--yellow-500);
    --green-bg: var(--green-50);
    --green-xlt: var(--green-100);
    --green-lt: var(--green-200);
    --green: var(--green-500);
    --green-dk: var(--green-600);
    --blue-bg-lt: var(--blue-50);
    --blue-bg: var(--blue-100);
    --blue-xlt: var(--blue-50);
    --blue-lt: var(--blue-100);
    --blue: var(--blue-500);
    --blue-dk: var(--blue-600);
    --navy-bg: var(--blue-50);
    --navy-lt: var(--blue-100);
    --navy-xlt-new: var(--blue-300);
    --navy-lt-new: var(--navy-400);
    --navy: var(--blue-600);
    --navy-dk: var(--blue-600);
    --navy-bg-active-new: var(--slate-500);
    --navy-dk-new: var(--slate-600);
    --navy-bg-new: var(--slate-700);
    --ai-blue: var(--slate-900);
    --ai-hover: var(--slate-950);
    --plum-xlt: var(--plum-50);
    --plum-bg: var(--plum-50);
    --plum-lt: var(--plum-100);
    --plum-bg-dk: var(--plum-300);
    --plum: var(--plum-600);
    --plum-dk: var(--plum-600);
    --ai-purple-pink-xxlt: var(--purple-10);
    --ai-purple-pink-xlt: var(--purple-50);
    --ai-purple-pink-lt: var(--purple-100);
    --ai-purple-pink-md: var(--purple-200);
    --ai-purple-pink: var(--purple-300);
    --ai-purple-xlt: var(--purple-400);
    --ai-purple-lt: var(--purple-500);
    --ai-purple-md: var(--purple-600);
    --ai-purple-primary: var(--purple-700);
    --ai-purple-dk: var(--purple-800);
    --tag-grey-lt: var(--grey-200);
    --tag-grey: var(--grey-400);
    --tag-grey-dk: var(--grey-600);
    --tag-red-lt: var(--red-100);
    --tag-red: var(--red-300);
    --tag-red-dk: var(--red-500);
    --tag-orange-lt: var(--orange-100);
    --tag-orange: var(--orange-200);
    --tag-orange-dk: var(--orange-400);
    --tag-yellow-lt: var(--yellow-100);
    --tag-yellow: var(--yellow-300);
    --tag-yellow-dk: var(--yellow-500);
    --tag-green-lt: var(--green-100);
    --tag-green: var(--green-300);
    --tag-green-dk: var(--green-400);
    --tag-blue-lt: var(--blue-50);
    --tag-blue: var(--blue-150);
    --tag-blue-dk: var(--blue-500);
    --tag-purple-lt: var(--plum-50);
    --tag-purple: var(--plum-200);
    --tag-purple-dk: var(--plum-400);
    --alert-bg: var(--red-50);
    --alert: var(--red-700);
    --overdue: var(--red-700);
    --error: var(--red-500);
    --warning-bg: var(--yellow-100);
    --warning: var(--orange-700);
    --success-bg: var(--green-100);
    --success: var(--green-700);
    --info-bg: var(--blue-50);
    --info: var(--blue-600);
    --support: var(--plum-600);
    --upgrade: var(--slate-900);
    --placeholder: var(--grey-500);
    --label: var(--grey-700);
    --text-hot: var(--orange-500);
    --text-users: var(--orange-700);
    --text-accounts: var(--plum-600);
    --text-contacts: var(--blue-600);
    --activity: var(--red-700);
    --task: var(--yellow-700);
    --product: var(--yellow-700);
    --product-bg: var(--yellow-700);
    --product-bg-hovered: var(--yellow-500);
    --lead: var(--green-600);
    --lead-hovered: var(--green-700);
    --person: var(--blue-600);
    --company: var(--plum-500);
    --icon-primary: var(--grey-700);
    --icon-primary-hovered: var(--grey-800);
    --icon-secondary: var(--grey-400);
    --icon-secondary-dk: var(--grey-600);
    --icon-primary-action: var(--grey-400);
    --icon-primary-action-hovered: var(--blue-400);
    --secondary-sidebar-text: var(--slate-400);
    --secondary-sidebar-hover-blue: var(--slate-550);
    --sidebar-list-loading: var(--slate-650);
    --sidebar-secondary: var(--slate-800);
    --sidebar-primary: var(--slate-900);
    --zebra-stripe: var(--grey-50);
    --skeleton-grey: var(--grey-100);
    --button-secondary: var(--grey-200);
    --button-secondary-dk: var(--grey-300);
    --form-border: var(--grey-400);
    --wallboard-red: var(--red-50);
    --background-hot: var(--orange-500);
    --banner-border-orange: var(--orange-600);
    --quote-signature-orange: var(--orange-600);
    --list-selected: var(--blue-50);
    --list-hovered: var(--blue-100);
    --focus-blue: var(--navy-600);
    --support-hover: var(--plum-700);
    --sidebar-red: var(--slate-900);
    --onboarding-help-lt: var(--plum-400);
    --onboarding-help: var(--plum-500);
    --onboarding-help-dk: var(--plum-600);
    --rcfx-sidebar-active: var(--navy-500);
    --rcfx-sidebar: var(--navy-750);
    --rcfx-sidebar-hover: var(--navy-800);
    --rcfx-sidebar-primary-item: var(--navy-900);
    --report-red: var(--red-400);
    --report-orange-bg: var(--orange-50);
    --report-orange: var(--orange-400);
    --report-green: var(--green-400);
    --report-blue: var(--blue-400);
    --report-navy: var(--slate-600);
    --social-x: var(--grey-900);
    --social-angel-list: var(--grey-900);
    --social-digg: var(--grey-900);
    --social-github: var(--grey-900);
    --social-facebook: var(--messenger-blue);
    --ai-purple-bg: var(--purple-10);
    --ai-purple-border: var(--purple-400);
    --ai-purple-box-shadow: var(--purple-100);
    --ai-purple-gradient-basic-one: var(--purple-500);
    --ai-purple-gradient-basic-two: var(--purple-700);
    --ai-purple-gradient-one: var(--purple-300);
    --ai-purple-gradient-two: var(--purple-500);
    --ai-purple-gradient-three: var(--purple-700);
    --ai-purple-gradient-expanded-one: var(--purple-200);
    --ai-purple-gradient-expanded-two: var(--purple-300);
    --ai-purple-gradient-expanded-three: var(--purple-500);
    --ai-purple-gradient-expanded-four: var(--purple-700);
    --ai-purple-gradient-bold-one: var(--purple-200);
    --ai-purple-gradient-bold-two: var(--purple-600);
    --ai-purple-gradient-bold-three: var(--purple-500);
    --ai-purple-gradient-bold-four: var(--purple-200);
    --ai-purple-gradient-bold-five: var(--purple-500);
    --ai-purple-gradient-bold-six: var(--purple-600);

    /* Screen Sizes */
    --page-width: 940px;
    --page-content-width: 680px;
    --page-sidebar-width: 220px;
    --page-alternate-sidebar-width: 260px;
    --page-alternate-content-width: 640px;
    --sidebar-width: 202px;
    --nm-sidebar-width: 420px;
    --header-height: 50px;
    --onboard-progress-height-lg: 98px;
    --onboard-progress-height-md: 81px;
    --onboard-progress-height-sm: 69px;
    --screen-xs-max: 767px;
    --screen-sm-min: 768px;
    --screen-sm-max: 991px;
    --screen-md-min: 992px;
    --screen-md-max: 1199px;
    --screen-lg-min: 1200px;
    --show-expanded-sidebar-width: 1200px;

    /* Component Sizes */
    --filter-drawer-width: 220px;
    --report-sidebar-width: 140px;
    --report-container-margin-left: 16px;

    /* Font Sizes */
    --font-huge: 21px;
    --font-big: 17px;
    --font-normal: 15px;
    --font-small: 13px;
    --font-tiny: 12px;

    /* Borders */
    --border-hairline: 1px solid #f1f1f1;

    /* Easing */
    --custom-easing: cubic-bezier(0.23, 1, 0.32, 1);
    --custom-easing-bounce: cubic-bezier(0.175, 0.885, 0.32, 1.275);
    --custom-easing-bounce-short: cubic-bezier(0.18, 0.89, 0.45, 1.06);
}
